import { HttpErrorResponse } from '@angular/common/http';
import { LogLevel, faro } from '@grafana/faro-web-sdk';

/**
 * Sends HTTP 5xx responses to Grafana Faro. Ignores 4xx and network errors without status.
 *
 * @param {HttpErrorResponse} errorResponse - The HTTP error returned by the backend.
 * @return {void} No return value.
 */
export function reportHttpServerErrorToFaro(errorResponse: HttpErrorResponse): void {
	if (!faro.api || errorResponse.status < 500) {
		return;
	}

	faro.api.pushLog([`HTTP ${errorResponse.status} ${errorResponse.url ?? 'unknown-url'}`], {
		level: LogLevel.ERROR,
		context: {
			statusCode: String(errorResponse.status)
		}
	});
}
